import { Field } from "./Field";

export class EditField {
  formField!: Field;
  fieldIndex?: number;
  conditionIndex?: number;
  preCondition?: number;
}
